export default "/_next/static/chunks/10.jpg.968edb80f9949e93e8f0a00f39bdfb86.chunk";